module.exports = __webpack_public_path__ + "static/media/logo-cmtech.ca3774a7.png";